import * as React from "react";

import { Block } from "../Block";
import { Form } from "../Form";
import { Input, FormControl } from "../Input";
import { Select } from "../Select";

import { useManualAddressForm } from "./useManualAddressForm";
import { getStateOptions, buildAddressComponents } from "./utils";

interface AddressValue {
  street?: string;
  city?: string;
  zipCode?: string;
  [key: string]: unknown; // Optionally handle additional dynamic properties
}
interface ManualAddressFormProps {
  value?: AddressValue;
  onChange?: (newValue: AddressValue) => void;
  onError?: (error: unknown) => void; // Define the error type more specifically if possible
  [key: string]: unknown; // To include additional props that might be passed
}

export function ManualAddressForm(props: ManualAddressFormProps) {
  const { value = {}, onChange, onError, ...restProps } = props;
  const initialValues = React.useMemo(() => buildAddressComponents(value), []);
  const { fieldProps, errors } = useManualAddressForm({
    initialValues,
    onChange,
    onError,
  });
  return (
    <Block width="100%" {...restProps}>
      <Form>
        <FormControl label="Street number & name" error={errors.streetLine}>
          <Input {...fieldProps.streetLine} />
        </FormControl>
        <FormControl label="Unit/Apartment (optional)" error={errors.unit}>
          <Input {...fieldProps.unit} />
        </FormControl>
        <FormControl label="Suburb" error={errors.suburb}>
          <Input {...fieldProps.suburb} />
        </FormControl>
        <FormControl label="State" error={errors.state}>
          <Select options={getStateOptions()} clearable={false} {...fieldProps.state} />
        </FormControl>
        <FormControl label="Post code" error={errors.postcode}>
          <Input {...fieldProps.postcode} />
        </FormControl>
      </Form>
    </Block>
  );
}
